// JSX runtime of the app's components (/** @jsxImportSource … */ at the top
// of each file): React's, with the texts in the interface's language.
import { jsx as reactJsx, jsxs as reactJsxs, Fragment } from 'react/jsx-runtime';
import { translateProps } from './index';

export const jsx = (type, props, key) => reactJsx(type, translateProps(props), key);
export const jsxs = (type, props, key) => reactJsxs(type, translateProps(props), key);
export { Fragment };
